import { render, staticRenderFns } from "./JiraConfig.vue?vue&type=template&id=3157b1d0&"
import script from "./JiraConfig.vue?vue&type=script&lang=js&"
export * from "./JiraConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3157b1d0')) {
      api.createRecord('3157b1d0', component.options)
    } else {
      api.reload('3157b1d0', component.options)
    }
    module.hot.accept("./JiraConfig.vue?vue&type=template&id=3157b1d0&", function () {
      api.rerender('3157b1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/configuration/JiraConfig.vue"
export default component.exports